import React from "react";
import { USER_ROLE_NEWS, USER_ROLE_NEWS_BIZAV } from "../common/roles/constants";
import { NEWS_NAMESPACE } from "../search/constants";
import { createDefaultSearchDefinition } from "../search/createDefaultSearchDefinition";
import { createSearchStore } from "../search/createSearchStore";
import { renderSearch } from "../search/renderSearch";
import { LayoutSwitcher } from "../search/result/LayoutSwitcher";
import { NewsSearchContainer } from "./NewsSearchContainer";
import { NewsSearchResult } from "./result/NewsSearchResult";
import { mapSearchCriterion, newsSearchCriteria } from "./searchComponents";
import { getDefaultNewsInput, newsViewOptions } from "./searchOptions";
import { searchPageProps } from "../common/types/search/search";

export default function NewsSearch({ roles }: searchPageProps) {
	const isFreeOrAnonymousUser =
		!roles[USER_ROLE_NEWS] && !roles[USER_ROLE_NEWS_BIZAV];

	const newsViewParams = isFreeOrAnonymousUser
		? [newsViewOptions[0]]
		: newsViewOptions;

	const store = createSearchStore(roles, getDefaultNewsInput(roles));

	let searchDefinition = createDefaultSearchDefinition({
		searchCriteria: newsSearchCriteria,
		resultsDisplay: NewsSearchResult,
		shouldFetchQuickSearchCriteria: false,
		mapSearchCriterion: mapSearchCriterion,
	});

	searchDefinition = {
		...searchDefinition,
		namespace: NEWS_NAMESPACE,
		layoutSwitcher: (
			<LayoutSwitcher
				criterionKey="display"
				dropdownItems={newsViewParams}
				saveToClientState={true}
				disabled={isFreeOrAnonymousUser}
			/>
		),
		searches: {
			searchAlertEnabled: true,
			searchesEnabled: !isFreeOrAnonymousUser,
			viewBindingEnabled: false,
		},
		searchTitle: "Latest News",
		showResultsOnInitialPageLoad: true,
		supportLink: "News",
	};

	return renderSearch(store, searchDefinition, NewsSearchContainer);
}
